import { KaitaiStreamWriter } from '@iotize/common/byte-stream';

import { POST, PUT } from '../annotations';
import { VirtualTap } from '../virtual-tap-server';

export class JvmService {

    public currentJvmCode = new KaitaiStreamWriter();

    get config() {
        return this.server.config;
    }

    constructor(public server: VirtualTap) {
        // this.server.bindConfigToRoute({
        //     path: '/1024//90',
        //     get: true,
        //     put: true,
        //     item: this.config.tap.lora,
        //     key: 'id'
        // });
    }

    @PUT({
        path: '/1024//74',
        auth: ['admin']
    })
    putAppendJvmCode(data: Uint8Array) {
        this.currentJvmCode.writeBytes(data);
    }

    @POST({
        path: '/1024//74',
        auth: ['admin']
    })
    clearCode() {
        this.currentJvmCode = new KaitaiStreamWriter();
    }

}